module.exports = __webpack_public_path__ + "static/media/mg.8ad4812e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/mg.png
// module id = 41
// module chunks = 0